import EquipmentPage from './equipmentPage.component';

export default EquipmentPage;